
import * as vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      minValDefault: 0,
      maxValueDefault: 0,
      minVal: 1,
      maxVal: 1,
      counter: 0,
      layeredForm: null,
      attributeCodeNumber: null,
      layeredRef: "layeredNav",
    };
  },
  props: {
    filterSimilarCapacity: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    filterSimilarCapacity(val) {
      if (val) {
        this.layeredForm[this.attributeCodeNumber] = [this.minVal, this.maxVal];
      } else
        this.layeredForm[this.attributeCodeNumber] = [this.minVal, this.minVal];
    },
  },

  methods: {
    decreaseMinVaule(value, form, attributeCode) {
      if (this.counter === 0) {
        this.minVal = value.minValue;
        this.maxVal = value.maxValue;
        this.minValDefault = value.minValue;
        this.maxValueDefault = value.maxValue;
      }

      if (this.minVal > 1) {
        this.minVal--;
        form[attributeCode] = [this.minVal, this.minVal];
        this.$emit("show-similar-capacity");
      }

      this.layeredForm = form;
      this.attributeCodeNumber = attributeCode;

      this.counter++;
    },

    increaseMinVaule(value, form, attributeCode) {
      if (this.counter === 0) {
        this.minVal = value.minValue;
        this.maxVal = value.maxValue;
        this.minValDefault = value.minValue;
        this.maxValueDefault = value.maxValue;
      }

      if (this.minVal < this.maxVal) {
        this.minVal++;

        form[attributeCode] = [this.minVal, this.minVal];
        this.$emit("show-similar-capacity");
      }

      this.layeredForm = form;
      this.attributeCodeNumber = attributeCode;

      this.counter++;
    },

    closeFiltersModal() {
      this.$emit("close-layered-nav");
    },
    clearFilters() {
      this.filterSimilarCapacity = false;

      if (
        this.attributeCodeNumber &&
        this.layeredForm[this.attributeCodeNumber]
      ) {
        this.minVal = this.minValDefault;
        this.maxVal = this.maxValueDefault;

        this.layeredForm[this.attributeCodeNumber] = [
          this.minValDefault,
          this.maxValueDefault,
        ];
      }

      this.$refs[this.layeredRef].resetFilters();
    },
  },
};
